// this wraps our implementation of the Google Tag Manager library
// this library is loaded by the Rails host app on every page

declare global {
  interface Window {
    dataLayer: GoogleTagManagerDataLayer;
  }
}

interface GoogleTagManagerDataLayer {
  push: (properties: DataLayerProperties) => void;
}

interface DataLayerProperties {
  // we can add other properties here as long as they are configured in our GTM account
  event: string;
  options?: GoogleTrackingOptions;
}

export type GoogleTrackingOptions = Record<string, string | boolean | number>;

export const gtmTrack = (eventName: string, options: GoogleTrackingOptions = {}) => {
  if (window.dataLayer) {
    window.dataLayer.push({ event: eventName, ...options });
  }
};
